import { Component } from 'react';
import AffairCard from './AffairCard';
import moment from 'moment';

class CustomerAffairsTab extends Component {

    render() {
        let affairsElements = [];
        this.props.affairs.sort((affairA, affairB) => {
            return moment(affairB.date_start, "YYYY-MM-DD").diff(moment(affairA.date_start, "YYYY-MM-DD"))
        }).forEach((affair, i) => {
            affairsElements.push(<AffairCard key={i} currentAffair={affair} />);
        })

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-margin row without-side-padding">
                {affairsElements}
            </div>
        )
    }
}

export default (CustomerAffairsTab);
